import React from 'react';
import { useProject } from '../context/ProjectContext';

export default function ValidationSummary(): React.ReactElement | null {
  const { validation, validationPending, validationUnavailable } = useProject();
  if (validationPending && validation === null) {
    return <div role="status" style={{ padding: '8px 12px', background: '#f6f8fa', color: '#57606a' }}>Validating project…</div>;
  }
  if (validationUnavailable) {
    return <div role="alert" style={{ padding: '10px 12px', background: '#fff8c5', color: '#633c01' }}>Validation unavailable: {validationUnavailable}. Current edits are preserved; saving is blocked until validation succeeds.</div>;
  }
  if (!validation || (validation.valid && validation.warnings.length === 0)) return null;
  const issues = validation.valid ? validation.warnings : validation.errors;
  return (
    <div role={validation.valid ? 'status' : 'alert'} style={{ padding: '10px 12px', background: validation.valid ? '#fff8c5' : '#ffebe9', color: validation.valid ? '#633c01' : '#82071e' }}>
      <strong>{validation.valid ? 'Compatibility warnings' : 'Project validation failed'}</strong>
      <ul style={{ margin: '6px 0 0', paddingLeft: 20 }}>
        {issues.slice(0, 5).map((issue, index) => <li key={`${issue.path}-${issue.code}-${index}`}><code>{issue.path}</code>: {issue.message}</li>)}
      </ul>
      {issues.length > 5 && <span>{issues.length - 5} more issue(s). Open JSON Editor for the complete list.</span>}
    </div>
  );
}
